import { AfterViewInit, ChangeDetectorRef, Component, ElementRef, Inject, OnInit, QueryList, ViewChild, ViewChildren } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { TicketDialogComponent } from '../../header/ticket-dialog/ticket-dialog.component';
import { DatePickerType, DialogConfig, DialogRef, FilterOperator, FilterOptions, FilterOptionsType, ISAPI, ISColumn, ISFilterAPI, ISPagination, ISSelectComponent, ISSelectDatasource, ISSelectOption, SpinnerService, ISSelectModule, MVListingConfigs, MVFilter, MVPagination } from 'is-lib';
import { FormGroup, FormControl, Validators, FormArray } from '@angular/forms';
import { UsersService } from 'src/app/services/users.service';
import { ClientPortalUser } from 'src/app/models/Client';
import { BehaviorSubject, buffer, distinctUntilChanged, finalize, forkJoin, Observable, Subscription } from 'rxjs';
import { CreateEntity, EntityExistenceAndPermissions } from 'src/app/models/Entity';
import { EntitiesService } from 'src/app/services/entities.service';
import { ServerResponse } from 'src/app/models/ServerResponse';
import { GroupingsService } from 'src/app/services/groupings.service';
import { CreateElectricityGrouping, CreateNaturalGasGrouping, Grouping, IGrouping } from 'src/app/models/Grouping';
import { EnergyMetersService } from 'src/app/services/energyMeters.service';
import { CreateElectricityMeterPT, CreateNaturalGasMeterPT, GasMeter, ElectricityMeter } from 'src/app/models/EnergyMeter';
import { MatExpansionPanel } from '@angular/material/expansion';
import { RegExpPatterns } from 'src/app/helpers/reg-exp-patterns';
import { environment } from 'src/environments/environment';
import { CreateEnergyOpportunityElectricityMeters, CreateEnergyOpportunityNaturalGasMeters, CreateOpportunity } from 'src/app/models/Opportunity';
import { OpportunitiesService } from 'src/app/services/opportunities.service';
import { AddressesService } from 'src/app/services/addresses.service';
import { left, read } from '@popperjs/core';
import { CreateElectricityMeterConsumption, CreateNaturalGasMeterConsumption, ElectricityMeterConsumption, NaturalGasMeterConsumption } from 'src/app/models/EnergyConsumptions';
import * as dateFns from 'date-fns'
import { SnackBarService } from 'src/app/services/snackbar.service';
import { SnackBarType } from 'src/app/models/Snackbar';
import * as _ from 'lodash';
import { AuthService } from 'src/app/services/auth.service';
import { ContractsService } from 'src/app/services/contracts.service';
import { contractTypes } from 'src/app/constants';
import { TranslateService } from '@ngx-translate/core';

@Component({
    selector: 'app-opportunity-form',
    templateUrl: './opportunity-form.component.html',
    styleUrls: ['./opportunity-form.component.scss'],
})
export class OpportunityFormComponent implements OnInit, AfterViewInit {
    
    @ViewChild('meInput') meRadioInput?: ElementRef;
    @ViewChildren(MatExpansionPanel) set setExpansionPanels(expansionPanels: QueryList<MatExpansionPanel>) {
        this.expansionPanels = expansionPanels.toArray();

        if (expansionPanels.length > 0) {
            if (this.recentlyAddedFlag) {
                expansionPanels.forEach((panel) => panel.expanded = false )

                let matExpansionElement = document.getElementById(expansionPanels.last.id);
                let expansionPanelWidth = matExpansionElement?.getBoundingClientRect().width;
                let cpeInputElement = matExpansionElement?.getElementsByClassName('form-control cpe-input');
                let hrElement = (matExpansionElement?.getElementsByTagName('hr').item(0) as HTMLElement);
                
                hrElement.style.marginLeft = `-${(expansionPanelWidth! - (+hrElement.getBoundingClientRect().width)) / 2}px`
                hrElement.style.width = `${expansionPanelWidth}px`;

                
                
                if (cpeInputElement) {
                    let cpeInput = cpeInputElement?.item(0) as HTMLInputElement

                    if (cpeInput) {
                        cpeInput.autofocus = true;
                        cpeInput.focus();
                    }
                }

                expansionPanels.last.expanded = true;
                this.recentlyAddedFlag = false;
            }
        }

    };

    contractTypes: ISSelectOption[];

    internalOrderCounter: number = 0;

    isOpen = false;

    expansionPanels: MatExpansionPanel[] = [];
    equipmentSelectedTabs: number[] = []
    protected selectedTab = 0;
    groupingName?: string;

    selectedGroupingForElectricity: boolean = false;
    selectedGroupingForNaturalGas: boolean = false;
    
    recentlyAddedFlag: boolean = false;
    equipmentsFromAPI: boolean = true;

    dateType: DatePickerType = DatePickerType.date

    countryCode: string = '';

    pressureLevel: string = '';
    tariffOption: string = '';
    tier: string = '';

    opportunityForm: FormGroup<OpportunityFormGroup> = new FormGroup<OpportunityFormGroup>({
        isOwnTin: new FormControl<boolean>(true, {nonNullable: true}),
        tin: new FormControl<number | null>(null, {updateOn: 'blur', validators: [Validators.required, Validators.maxLength(9), Validators.minLength(9)]}),
        entity: new FormControl<string | null>(null),
        date: new FormControl<Date | null>(null, Validators.required),
        name: new FormControl<string | null>(null, Validators.required),
        contractType: new FormControl<string | null>(null, Validators.required),
        groupingId: new FormControl<string | null>(null, Validators.required),
        opportunityId: new FormControl<string | null>(null),
        loyaltyPeriod: new FormControl<number | null>(null),
        electricityEquipments: new FormArray<FormGroup<ElectricityFormGroup>>([]),
        naturalGasEquipments: new FormArray<FormGroup<NaturalGasFormGroup>>([])
    });

    tensionLevelDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>(
        {
            apiUrl: `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/TensionLevels`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    timeCyclesDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>(
        {
            apiUrl: `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/TimeCycles`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    countTypesDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>(
        {
            apiUrl: `${environment.apiUrl}Electricity/${this._userService.userCountryCode}/CountingCycles`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    )

    pressureLevelDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>(
        {
            apiUrl: `${environment.apiUrl}NaturalGas/${this._userService.userCountryCode}/PressureLevels`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    tariffOptionDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>(
        {
            apiUrl: `${environment.apiUrl}NaturalGas/${this._userService.userCountryCode}/TariffOptions`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    );

    tierDatasource$: BehaviorSubject<ISSelectDatasource> = new BehaviorSubject<ISSelectDatasource>(
        {
            apiUrl: `${environment.apiUrl}NaturalGas/${this._userService.userCountryCode}/Tiers`,
            columns: [
                new ISColumn('id', 'ID'),
                new ISColumn('description', 'DESCRIPTION', new FilterOptions('', FilterOptionsType.text, FilterOperator.contains))
            ],
            pagination: new ISPagination(25, 0),
            totalItems: 0,
            codeBTN: false,
            codeBtnDialog: false,
            codeBtnId: null
        }
    )

    formGroupInitialValue?: any;

    parishOptions: ISSelectOption[][] = []
    loyaltyPeriodOptions: ISSelectOption[] = [
        new ISSelectOption(12, '12 Meses'),
        new ISSelectOption(18, '18 Meses'),
        new ISSelectOption(24, '24 Meses')
    ]
    
    constructor(       
        private _dialogConfig: DialogConfig,
        private _userService: UsersService,
        private _entityService: EntitiesService,
        private _groupingService: GroupingsService,
        private _energyMetersService: EnergyMetersService,
        private _opportunityService: OpportunitiesService,
        private _addressService: AddressesService,
        private _cdRef: ChangeDetectorRef,
        private _snackbarService: SnackBarService,
        private _translate: TranslateService,
        private _spinnerService: SpinnerService,
        private _dialogRef: DialogRef,
    ) { 
        this.countryCode = _userService.userCountryCode.toUpperCase();
        
        this.contractTypes = contractTypes.map( (type) => {
            let contractTypeGuid = Object.entries(environment.contractTypeIds).find( (contractType) => contractType[0] == type.id )?.[1];

            return new ISSelectOption(contractTypeGuid, type.invariantCultureDescription, type.icon);
        })
    }

    ngOnInit(): void { 

        if (this._dialogConfig.data.opportunityId) {          
            this.editingServiceCalls(this._dialogConfig.data.opportunityId);
        }
        this._cdRef.detectChanges();
    }

    ngAfterViewInit(): void {
        this.formSubscriptions();
        
        if (String.isNullOrUndefinedOrWhitespace(this._userData.tin)) {
            this._formControls.isOwnTin.setValue(false);
            if (this.meRadioInput != null) {
                this.meRadioInput.nativeElement.disabled = true;
            }
        } else {
            this._formControls.isOwnTin.setValue(true);
        }

        if (!String.isNullOrUndefinedOrWhitespace(this._dialogConfig.data.groupingId)) {
            this._formControls.groupingId.setValue(this._dialogConfig.data.groupingId);
            this._formControls.groupingId.disable();

            let groupingsAPI = new MVListingConfigs([
                new MVFilter('Id', this._formControls.groupingId.value!, FilterOptionsType.text, FilterOperator.equals)
            ], 
            null,
            new MVPagination(0, 999)
            )

            this._groupingService.getGroupings(groupingsAPI).subscribe( (sr: ServerResponse<IGrouping[]>) => {
                if (sr.data && sr.data.length == 1) {
                    let grouping = sr.data[0];
                    this.selectedGroupingForElectricity = grouping.forElectricity;
                    this.selectedGroupingForNaturalGas = grouping.forNaturalGas;
                    this.groupingName = grouping.internalCode;
                }
            });
        }
    }

    formSubscriptions() {
        //#region IS OWN TIN
        this._formControls.isOwnTin.valueChanges.subscribe( (isOwnTin: boolean) => {
            if (isOwnTin) {
                this._formControls.tin.setValue(this._userData.tin != null ? +this._userData.tin : null);
                this._formControls.tin.disable();
            } else {
                this._formControls.tin.setValue(null);
                this._formControls.name.setValue(null);
                this._formControls.tin.enable();
            }
        });
        //#endregion

        //#region TIN
        this._formControls.tin.valueChanges.pipe(distinctUntilChanged()).subscribe( (tin: number | null) => {
            if (this._formControls.tin.valid && !String.isNullOrUndefinedOrWhitespace(tin?.toString())) {
                this._entityService.getEntityByTin(tin!.toString(), undefined, false).subscribe( (sr: ServerResponse<EntityExistenceAndPermissions>) => {
                    if (sr.data && sr.data.exists) {
                        this._formControls.entity.setValue(sr.data.id);
                        this._formControls.name.setValue(sr.data.name);
                        this._formControls.name.disable();
                    } else {
                        this._formControls.entity.setValue(null);
                        this._formControls.name.setValue(null);
                        this._formControls.name.enable();
                    }
                })
            } else {
                this._formControls.entity.setValue(null);
                this._formControls.name.enable();
            }
        });
        //#endregion
    }

    editingServiceCalls(opportunityId: string) {
        this._opportunityService.getOpportunity(opportunityId).subscribe((op: ServerResponse<any>) => {
            if (op.data != null) {
                this.opportunityForm.controls.entity.setValue(op.data.entity.id);
                this.opportunityForm.controls.date.setValue(op.data.date);
                this.opportunityForm.controls.opportunityId.setValue(op.data.id);
                this.opportunityForm.controls.loyaltyPeriod.setValue(op.data.preferentialLoyaltyPeriodMonths);

                this.formGroupInitialValue = this.opportunityForm.getRawValue();

                this._opportunityService.getOpportunityElectricityMeters(op.data.id).subscribe( (electricityMeters: ServerResponse<any[]>) => {
                    if (electricityMeters.data && electricityMeters.data.length > 0) {
                        this.equipmentsFromAPI = true;
                        electricityMeters.data.forEach((em) => {
                            this.addElectricityEquipment(em);
                            
                        });
                    }
                });

                this._opportunityService.getOpportunityNaturalGasMeters(op.data.id).subscribe( (naturalGasMeters: ServerResponse<any[]>) => {
                    if (naturalGasMeters.data && naturalGasMeters.data.length > 0) {
                        this.equipmentsFromAPI = true;
                        naturalGasMeters.data.forEach((em) => {
                            this.addNaturalGasEquipment(em);
                            
                        });
                    }
                });
            }
            
        });
    }

    addElectricityEquipment(energyOportunityMeter?: any) {
        this._electricityEquipmentFormArray.push(
            new FormGroup<ElectricityFormGroup>({
                equipmentCode: new FormControl<string | null>(null, [Validators.required, Validators.pattern(this._meterCodeRegexpPattern(true))]),
                equipmentId: new FormControl<number | null>(energyOportunityMeter?.electricityMeterId),
                contractedPower: new FormControl<number | undefined>(energyOportunityMeter?.electricityMeterContractedPower, { nonNullable: true, validators: Validators.required }),
                tensionLevel: new FormControl<string | undefined>(energyOportunityMeter?.electricityMeterTensionLevel, { nonNullable: true, validators: Validators.required }),
                tensionLevelString: new FormControl<string | undefined>(undefined, { nonNullable: true }),
                timeCycle: new FormControl<string | undefined>(energyOportunityMeter?.electricityMeterTimeCycle, { nonNullable: true, validators: Validators.required }),
                countType: new FormControl<string | undefined>(energyOportunityMeter?.electricityMeterCountType, { nonNullable: true, validators: Validators.required }),
                countTypeString: new FormControl<string | undefined>(undefined, { nonNullable: true }),
                county: new FormControl<string>(energyOportunityMeter?.address?.county, { nonNullable: true, validators: Validators.required }),
                district: new FormControl<string>(energyOportunityMeter?.address?.district, { nonNullable: true, validators: Validators.required }),
                locality: new FormControl<string>(energyOportunityMeter?.address?.locality, { nonNullable: true, validators: Validators.required }),
                parish: new FormControl<number>(energyOportunityMeter?.address?.parish, { nonNullable: true, validators: Validators.required }),
                street: new FormControl<string>(energyOportunityMeter?.address?.street, { nonNullable: true }),
                floor: new FormControl<string>(energyOportunityMeter?.address?.floorFraction, { nonNullable: true }),
                door: new FormControl<string>(energyOportunityMeter?.address?.doorNumber, { nonNullable: true }),
                postalCode: new FormControl<string>(energyOportunityMeter?.address?.postalCode, [Validators.required, Validators.pattern(this._zipCodeRegexpPattern())]),
                postalCodeId: new FormControl<number>(energyOportunityMeter?.address?.postalCodeId),
                consumptions: new FormArray<FormGroup<ConsumptionsFormGroup>>([]),
                offPeakEnergyPrice: new FormControl<number | null>(null),
                peakEnergyPrice: new FormControl<number | null>(null),
                standardEnergyPrice: new FormControl<number | null>(null),
                superOffPeakEnergyPrice: new FormControl<number | null>(null),
                hasPriceInput: new FormControl<boolean | undefined>(false, {nonNullable: true}),
                hasSingleMonthConsumptionsInput: new FormControl<boolean | undefined>(false, {nonNullable: true}),
                associatedWithOpportunity: new FormControl<boolean>(energyOportunityMeter != null, { nonNullable: true }),
                deleted: new FormControl<boolean>(false, { nonNullable: true }),
                internalOrder: new FormControl<number>(this.internalOrderCounter, { nonNullable: true })
            })
        );        

        this.internalOrderCounter += 1;
        
        //#region Equipment Form subscriptions 
        let newlyAddedFormGroup = this._electricityEquipmentFormArrayAt(-1);
        let newlyAddedEquipmentIndex = this._equipmentFormArrayControls.length - 1;

        newlyAddedFormGroup?.controls.equipmentCode.valueChanges.pipe(distinctUntilChanged()).subscribe((equipmentCode: string | null) => {
            if (newlyAddedFormGroup!.controls.equipmentCode.valid) {
                let request: Observable<ServerResponse<ElectricityMeter | GasMeter>>;
                newlyAddedFormGroup!.controls.equipmentCode.setValue(newlyAddedFormGroup!.controls.equipmentCode.value!.replaceAll(' ', ''), { emitEvent: false });

                if (this.codeIsDuplicate(newlyAddedFormGroup!.controls.equipmentCode.value!)) {
                    newlyAddedFormGroup!.controls.equipmentCode.setErrors({notUnique: true})
                    return;
                }

                this._energyMetersService.getElectricityMeterByCode(newlyAddedFormGroup!.controls.equipmentCode.value!).subscribe( {
                    next: (sr: ServerResponse<ElectricityMeter>) => {
                        if (sr.data != null ) {

                            let meter = sr.data as ElectricityMeter;

                            newlyAddedFormGroup!.patchValue({
                                equipmentId: meter.id,
                                contractedPower: meter.contractedPower,
                                tensionLevel: meter.tensionLevelId,
                                timeCycle: meter.timeCycleId,
                                equipmentCode: meter.code,
                                countType: meter.countTypeId,
                                associatedWithOpportunity: newlyAddedFormGroup!.controls.associatedWithOpportunity.value,
                                county: meter.address?.county,
                                district: meter.address?.district,
                                locality: meter.address?.locality,
                                parish: meter.address?.parish,
                                postalCode: meter.address?.postalCode ?? null,
                                postalCodeId: meter.address?.postalCodeId ?? null,
                                street: meter.address?.street,
                                floor: meter.address?.floorFraction,
                                door: meter.address?.doorNumber,
                                hasPriceInput: false,
                                offPeakEnergyPrice: 0,
                                peakEnergyPrice: 0,
                                standardEnergyPrice: 0,
                                superOffPeakEnergyPrice: 0,
                                consumptions: [],
                                deleted: false,
                                countTypeString: this._translate.instant(meter.countType),
                                tensionLevelString: meter.tensionLevel
                            });
                            
                            let endDate = dateFns.subMonths(new Date(), 2);
                            let startDate = dateFns.startOfMonth(dateFns.subMonths(endDate, 11));

                            this._energyMetersService.getElectricityMeterConsumptions(meter.id, startDate.toDateString(), endDate.toDateString()).subscribe((sr_1: ServerResponse<ElectricityMeterConsumption[]>) => {
                                
                                newlyAddedFormGroup!.controls.consumptions.controls.push(...sr_1.data.map( (consumption) => 
                                    {
                                        let fg = new FormGroup<ConsumptionsFormGroup>({
                                            date: new FormControl<Date>(consumption.date, {nonNullable: true}),
                                            offPeak: new FormControl<number | undefined>(consumption.offPeak, {nonNullable: true, validators: Validators.required}),
                                            peak: new FormControl<number | undefined>(consumption.peak, {nonNullable: true, validators: Validators.required}),
                                            standard: new FormControl<number | undefined>(consumption.standard, {nonNullable: true, validators: Validators.required}),
                                            superOffPeak: new FormControl<number | undefined>(consumption.superOffPeak, {nonNullable: true, validators: Validators.required}),
                                            gas: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                                            id: new FormControl<number | undefined>(consumption.id, {nonNullable: true}),
                                            singleLine: new FormControl<boolean>(false, {nonNullable: true})
                                        })
                                        fg.disable();
                                        return fg;
                                    }
                                ));
                                
                                if (!newlyAddedFormGroup!.disabled) {
                                    newlyAddedFormGroup!.disable();
                                    newlyAddedFormGroup!.controls.equipmentCode.enable();
                                    newlyAddedFormGroup!.controls.hasPriceInput.enable();
                                    newlyAddedFormGroup!.controls.hasSingleMonthConsumptionsInput.enable();
                                    newlyAddedFormGroup!.controls.offPeakEnergyPrice.enable();
                                    newlyAddedFormGroup!.controls.peakEnergyPrice.enable();
                                    newlyAddedFormGroup!.controls.standardEnergyPrice.enable();
                                    newlyAddedFormGroup!.controls.superOffPeakEnergyPrice.enable();
                                }

                                if (this.formGroupInitialValue != null) {
                                    this.formGroupInitialValue = this.opportunityForm.getRawValue();
                                }
                                
                            });
                        } else {
                            newlyAddedFormGroup!.enable();
                        }
                    },
                    error: (err) => {
                        newlyAddedFormGroup!.enable();
                    }
                });
            }
        })

        newlyAddedFormGroup?.controls.postalCode.valueChanges.pipe(distinctUntilChanged()).subscribe((postalCode: string | null) => {
            if (newlyAddedFormGroup!.controls.postalCode.valid) {
                (this.countryCode == 'PT' ? this._addressService.getPostalCodePT(postalCode!) : this._addressService.getPostalCodeES(postalCode!)).subscribe( (sr: ServerResponse<any>) => {
                    if (sr.data != null ) {
                        newlyAddedFormGroup!.controls.postalCodeId.setValue(sr.data.id);

                        newlyAddedFormGroup!.controls.county.setValue(sr.data.county);
                        newlyAddedFormGroup!.controls.district.setValue(sr.data.district);
                        newlyAddedFormGroup!.controls.locality.setValue(sr.data.locality);

                        newlyAddedFormGroup!.controls.county.disable();
                        newlyAddedFormGroup!.controls.district.disable();
                        newlyAddedFormGroup!.controls.locality.disable();

                        this._addressService.getParishes(sr.data.fkCounty).subscribe( (sr_1: ServerResponse<any[]>) => {
                            if (sr_1.data && sr_1.data.length > 0) {
                                this.parishOptions[newlyAddedEquipmentIndex] = sr_1.data.map( (parish) => new ISSelectOption(parish.id, parish.name));
                            }
                        });
                    }
                } )
            }
        })
        //#endregion

        this.parishOptions.push([]);
        this.equipmentSelectedTabs.push(0);

        if (energyOportunityMeter == null) {
            this.recentlyAddedFlag = true;
        } else {
            newlyAddedFormGroup!.controls.equipmentCode.setValue(energyOportunityMeter?.electricityMeterCode);
            newlyAddedFormGroup!.disable();
        }
    }

    addNaturalGasEquipment(naturalgGasEnergyOportunityMeter?: any) {
        this._naturalGasEquipmentFormArray.push(
            new FormGroup<NaturalGasFormGroup>({
                equipmentCode: new FormControl<string | null>(null, [Validators.required, Validators.pattern(this._meterCodeRegexpPattern(false))]),
                equipmentId: new FormControl<number | null>(naturalgGasEnergyOportunityMeter?.naturalGasMeterId),
                pressureLevel: new FormControl<string>(naturalgGasEnergyOportunityMeter?.naturalGasPressureLevel, { nonNullable: true, validators: Validators.required }),
                tariffOption: new FormControl<string>(naturalgGasEnergyOportunityMeter?.naturalGasTariffOption, { nonNullable: true, validators: Validators.required }),
                tier: new FormControl<string>(naturalgGasEnergyOportunityMeter?.naturalGasTier, { nonNullable: true }),
                county: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.county, { nonNullable: true }),
                district: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.district, { nonNullable: true }),
                locality: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.locality, { nonNullable: true }),
                parish: new FormControl<number>(naturalgGasEnergyOportunityMeter?.address?.parish, { nonNullable: true, validators: Validators.required }),
                street: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.street, { nonNullable: true }), 
                floor: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.floorFraction, { nonNullable: true }),
                door: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.doorNumber, { nonNullable: true }),
                postalCode: new FormControl<string>(naturalgGasEnergyOportunityMeter?.address?.postalCode, [Validators.required, Validators.pattern(this._zipCodeRegexpPattern())]),
                postalCodeId: new FormControl<number>(naturalgGasEnergyOportunityMeter?.address?.postalCodeId),
                consumptions: new FormArray<FormGroup<ConsumptionsFormGroup>>([]),
                energyPrice: new FormControl<number | null>(null),
                hasPriceInput: new FormControl<boolean | undefined>(false, {nonNullable: true}),
                hasSingleMonthConsumptionsInput: new FormControl<boolean | undefined>(false, {nonNullable: true}),
                associatedWithOpportunity: new FormControl<boolean>(naturalgGasEnergyOportunityMeter != null, { nonNullable: true }),
                deleted: new FormControl<boolean>(false, { nonNullable: true }),
                internalOrder: new FormControl<number>(this.internalOrderCounter, { nonNullable: true })
            })
        );

        this.internalOrderCounter += 1;
        
        //#region Equipment Form subscriptions 
        let newlyAddedFormGroup = this._naturalGasEquipmentFormArrayAt(-1);
        let newlyAddedEquipmentIndex = this._equipmentFormArrayControls.length - 1;

        newlyAddedFormGroup?.controls.pressureLevel.valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
            if (value) {
                this.onPressureLevelSelected(value);
            }
            else
                this.pressureLevel = '';
        });

        newlyAddedFormGroup?.controls.tariffOption.valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
            if(value){
                this.onTariffOptionSelected(value);
            }
            else
                this.tariffOption = '';
        })
        
        newlyAddedFormGroup?.controls.tier.valueChanges.pipe(distinctUntilChanged()).subscribe((value) => {
            if(value){
                this.onTierOptionsSelected(value);
            }
            else
                this.tier = '';
        })

        newlyAddedFormGroup?.controls.equipmentCode.valueChanges.pipe(distinctUntilChanged()).subscribe((equipmentCode: string | null) => {
            if (newlyAddedFormGroup!.controls.equipmentCode.valid) {
                let request: Observable<ServerResponse<GasMeter>>;
                newlyAddedFormGroup!.controls.equipmentCode.setValue(newlyAddedFormGroup!.controls.equipmentCode.value!.replaceAll(' ', ''), { emitEvent: false });

                if (this.codeIsDuplicate(newlyAddedFormGroup!.controls.equipmentCode.value!)) {
                    newlyAddedFormGroup!.controls.equipmentCode.setErrors({notUnique: true})
                    return;
                }
                this._energyMetersService.getNaturalGasMeterByCode(newlyAddedFormGroup!.controls.equipmentCode.value!).subscribe( (sr: ServerResponse<GasMeter>) => {
                    if (sr.data != null ) {

                        let meter = sr.data as GasMeter;

                        newlyAddedFormGroup!.patchValue({
                            equipmentId: meter.id,
                            pressureLevel: meter.pressureLevelId,
                            tariffOption: meter.tariffOption,
                            tier: meter.tierId,
                            equipmentCode: meter.code,
                            associatedWithOpportunity: newlyAddedFormGroup!.controls.associatedWithOpportunity.value,
                            county: meter.address?.county,
                            district: meter.address?.district,
                            locality: meter.address?.locality,
                            parish: meter.address?.parish,
                            postalCode: meter.address?.postalCode ?? null,
                            postalCodeId: meter.address?.postalCodeId ?? null,
                            street: meter.address?.street,
                            floor: meter.address?.floorFraction,
                            door: meter.address?.doorNumber,
                            hasPriceInput: false,
                            energyPrice: 0,
                            consumptions: [],
                            deleted: false
                        });
                        
                        let endDate = dateFns.subMonths(new Date(), 2);
                        let startDate = dateFns.startOfMonth(dateFns.subMonths(endDate, 11));

                        this._energyMetersService.getNaturalGasMeterConsumptions(meter.id, startDate.toDateString(), endDate.toDateString()).subscribe((sr_1: ServerResponse<NaturalGasMeterConsumption[]>) => {
                            
                            newlyAddedFormGroup!.controls.consumptions.controls.push(...sr_1.data.map( (consumption) => 
                                {
                                    let fg = new FormGroup<ConsumptionsFormGroup>({
                                        date: new FormControl<Date>(consumption.date, {nonNullable: true}),
                                        offPeak: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                                        peak: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                                        standard: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                                        superOffPeak: new FormControl<number | undefined>(undefined, {nonNullable: true}),
                                        gas: new FormControl<number | undefined>(consumption.consumption, {nonNullable: true, validators: Validators.required}),
                                        id: new FormControl<number | undefined>(consumption.id, {nonNullable: true}),
                                        singleLine: new FormControl<boolean>(false, {nonNullable: true})
                                    })
                                    fg.disable();
                                    return fg;
                                }
                            ));
                            
                            if (!newlyAddedFormGroup!.disabled) {
                                newlyAddedFormGroup!.disable();
                            }

                            if (this.formGroupInitialValue != null) {
                                this.formGroupInitialValue = this.opportunityForm.getRawValue();
                            }
                        });

                    } else {
                        newlyAddedFormGroup!.enable();
                    }
                });


                
            }
        })

        newlyAddedFormGroup?.controls.postalCode.valueChanges.pipe(distinctUntilChanged()).subscribe((postalCode: string | null) => {
            if (newlyAddedFormGroup!.controls.postalCode.valid) {
                (this.countryCode == 'PT' ? this._addressService.getPostalCodePT(postalCode!) : this._addressService.getPostalCodeES(postalCode!)).subscribe( (sr: ServerResponse<any>) => {
                    if (sr.data != null ) {
                        newlyAddedFormGroup!.controls.postalCodeId.setValue(sr.data.id);

                        newlyAddedFormGroup!.controls.county.setValue(sr.data.county);
                        newlyAddedFormGroup!.controls.district.setValue(sr.data.district);
                        newlyAddedFormGroup!.controls.locality.setValue(sr.data.locality);

                        newlyAddedFormGroup!.controls.county.disable();
                        newlyAddedFormGroup!.controls.district.disable();
                        newlyAddedFormGroup!.controls.locality.disable();

                        this._addressService.getParishes(sr.data.fkCounty).subscribe( (sr_1: ServerResponse<any[]>) => {
                            if (sr_1.data && sr_1.data.length > 0) {
                                this.parishOptions[newlyAddedEquipmentIndex] = sr_1.data.map( (parish) => new ISSelectOption(parish.id, parish.name));
                            }
                        });
                    }
                } )
            }
        })
        //#endregion

        this.parishOptions.push([]);
        this.equipmentSelectedTabs.push(0);  

        if (naturalgGasEnergyOportunityMeter == null) {
            this.recentlyAddedFlag = true;
        } else {
            newlyAddedFormGroup!.controls.equipmentCode.setValue(naturalgGasEnergyOportunityMeter?.naturalGasMeterCode);
            newlyAddedFormGroup!.disable();
        }
        


    }

    onPressureLevelSelected(value: any) {
        let sourceToLook = this.pressureLevelDatasource$.value.body;
        this.pressureLevel = sourceToLook?.find(x => x.id == value).description;
    }
    
    onTariffOptionSelected(value: any) {
        let sourceToLook = this.tariffOptionDatasource$.value.body;
        this.tariffOption = sourceToLook?.find(x => x.id == value).description;
    }

    onTierOptionsSelected(value: any) {
        let sourceToLook = this.tierDatasource$.value.body;
        this.tier = sourceToLook?.find(x => x.id == value).description;
    }


    removeEquipment(index: number, internalOrder: number) {

        let groupToDeleteIsElectricity = this.formGroupIsElectricity(this._equipmentFormArrayControls.at(index)!.controls);

        if (groupToDeleteIsElectricity) {
            index = this._electricityEquipmentFormArrayControls.findIndex( (fg: FormGroup<ElectricityFormGroup>) => fg.controls.internalOrder.value == internalOrder );

            if (this._electricityEquipmentFormArray.at(index).controls.associatedWithOpportunity.value) {
                this._electricityEquipmentFormArray.at(index).disable();
                this._electricityEquipmentFormArray.at(index).controls.deleted.setValue(true);
            } else {
                this._electricityEquipmentFormArray.removeAt(index);
            }
        } else {
            index = this._naturalGasEquipmentFormArrayControls.findIndex( (fg: FormGroup<NaturalGasFormGroup>) => fg.controls.internalOrder.value == internalOrder );
            
            if (this._naturalGasEquipmentFormArray.at(index).controls.associatedWithOpportunity.value) {
                this._naturalGasEquipmentFormArray.at(index).disable();
                this._naturalGasEquipmentFormArray.at(index).controls.deleted.setValue(true);
            } else {
                this._naturalGasEquipmentFormArray.removeAt(index);
            }
        }

        this.parishOptions.splice(index, 1);
        this.equipmentSelectedTabs.splice(index, 1);
    }

    submitCreateOpportunity() {
        if(this.opportunityForm.controls.naturalGasEquipments.value.length == 0 && this.opportunityForm.controls.electricityEquipments.value.length == 0) {
            this._snackbarService.callSnackBar('AT_LEAST_ONE_METER_REQUIRED', SnackBarType.ERROR);
            return;
        }
        if (this.opportunityForm.controls.entity.value == null) {
            let entity: CreateEntity = {
                name: this.opportunityForm.controls.name.value!,
                tin: this.opportunityForm.controls.tin.value!
            }

            this._entityService.postEntity(entity, false).subscribe( (sr: ServerResponse<any>) => {
                if (sr.data != null) {
                    this.opportunityForm.controls.entity.setValue(sr.data);

                    this.submitCreateOpportunity();
                }
            });
        } else {
            let entityId = this.opportunityForm.controls.entity.value;
            let nonCreatedElectricityEquipments = this._electricityEquipmentFormArray.controls.filter( (fg: FormGroup<ElectricityFormGroup>) => fg.controls.equipmentId.value == null );
            let nonCreatedNaturalGasEquipments = this._naturalGasEquipmentFormArray.controls.filter( (fg: FormGroup<NaturalGasFormGroup>) => fg.controls.equipmentId.value == null );
            
            if (nonCreatedElectricityEquipments.length > 0 ) {
                this.submitElectricityEquipments(nonCreatedElectricityEquipments);
            } else if (nonCreatedNaturalGasEquipments.length > 0 ) {
                this.submitNaturalGasEquipments(nonCreatedNaturalGasEquipments);
            } else {
                if (this.opportunityForm.controls.opportunityId.value == null) {
                    let opportunityToCreate: CreateOpportunity = {
                        entityId: entityId,
                        originEntityId: entityId,
                        businessTypeId: 1, // Energia
                        date: this.opportunityForm.controls.date.value!,
                        contactOriginTypeId: environment.opportunityContactOrigin,
                        preferentialLoyaltyPeriodMonths: this.opportunityForm.controls.loyaltyPeriod.value ?? undefined
                    }

                    this._opportunityService.createEnergyOpportunity(opportunityToCreate).subscribe( (sr: ServerResponse<string>) => {
                        if (sr.data != null) {
                            this.opportunityForm.controls.opportunityId.setValue(sr.data);
                            this.submitCreateOpportunity();
                        }
                    });

                } else {

                    this.associateEnergyMetersToOpportunity(this.opportunityForm.controls.opportunityId.value);
                    
                }
            }
        }
    }

    submitElectricityEquipments(nonCreatedEquipments: FormGroup<ElectricityFormGroup>[]) {
        let electricityMeters: CreateElectricityMeterPT[] = nonCreatedEquipments
            .map((fg: FormGroup<ElectricityFormGroup>) => { 
                const electricityMeterData = fg.value!;
                return { 
                    code: electricityMeterData.equipmentCode!, 
                    contractedPower: electricityMeterData.contractedPower!, 
                    countTypeId: electricityMeterData.countType!,
                    isISPFree: false,
                    tensionLevelId: electricityMeterData.tensionLevel!,
                    timeCycleId: electricityMeterData.timeCycle!,
                    address: {
                        country: this._userData.countryId,
                        postalCode: electricityMeterData.postalCode!,
                        postalCodeId: electricityMeterData.postalCodeId!,
                        parishId: +electricityMeterData.parish!,
                        street: electricityMeterData.street,
                        floorFraction: electricityMeterData.floor,
                        doorNumber: electricityMeterData.door
                    }
                }
            }
        );

        let electricityMetersRequest: {[key: string]: Observable<ServerResponse<any>>} = {};
        
        electricityMeters.forEach((meter: CreateElectricityMeterPT) => {
            electricityMetersRequest[meter.code] = this._energyMetersService.postElectricityMeter(meter);
        });

        forkJoin(electricityMetersRequest).subscribe( (srs: {[key: string]: ServerResponse<any>}) => {
            Object.entries(srs).forEach( ([key, response]) => {
                if (response.data != null) {
                    let associatedControl = this._nonDeletedElectricityEquipmentFormArrayControls.find( (fg: FormGroup<ElectricityFormGroup>) => fg.controls.equipmentCode.value == key);
                    associatedControl?.controls.equipmentId.setValue(response.data);
                }
            });
            
            this.submitCreateOpportunity();
        });
    }

    associateEnergyMetersToOpportunity(opportunityId: string) {

        let electricityMetersToInsert: {electricityMeters: CreateEnergyOpportunityElectricityMeters[]} = {
            electricityMeters: []
        }
        let naturalGasMetersToInsert: {naturalGasMeters: CreateEnergyOpportunityNaturalGasMeters[]} = {
            naturalGasMeters: []
        }

        let observables: Observable<ServerResponse<any>>[] = [];

        this._nonDeletedElectricityEquipmentFormArrayControls.forEach((fg: FormGroup<ElectricityFormGroup>) => {
            let newCreateObject = new CreateEnergyOpportunityElectricityMeters(
                fg.controls.equipmentId.value!,
                fg.controls.consumptions.controls.at(-1)?.controls.date.value,
                0, 0 ,0 ,0, 0, 0, 0, 0)

            let electricityMeter = fg.controls.consumptions.controls.reduce<CreateEnergyOpportunityElectricityMeters>((obj, consumptionGroup) => {
                obj.offPeakEstimatedAnnualConsumption! += +(consumptionGroup.controls.offPeak.value ?? 0);
                obj.peakEstimatedAnnualConsumption! += +(consumptionGroup.controls.peak.value ?? 0);
                obj.standardEstimatedAnnualConsumption! += +(consumptionGroup.controls.standard.value ?? 0);
                obj.superOffPeakEstimatedAnnualConsumption! += +(consumptionGroup.controls.superOffPeak.value ?? 0);
                return obj;
            }, newCreateObject);

            if (fg.controls.hasPriceInput.value) {
                electricityMeter.offPeakEnergyPrice! = +(fg.controls.offPeakEnergyPrice.value ?? 0);
                electricityMeter.peakEnergyPrice! = +(fg.controls.peakEnergyPrice.value ?? 0);
                electricityMeter.standardEnergyPrice! = +(fg.controls.standardEnergyPrice.value ?? 0);
                electricityMeter.superOffPeakEnergyPrice! = +(fg.controls.superOffPeakEnergyPrice.value ?? 0);
            }
            
            electricityMetersToInsert.electricityMeters.push(electricityMeter);
        });

        this._nonDeletedNaturalGasEquipmentFormArrayControls.forEach((fg: FormGroup<NaturalGasFormGroup>) => {
            let newCreateObject = new CreateEnergyOpportunityNaturalGasMeters(fg.controls.equipmentId.value!,0, 0)

            let naturalGasMeter = fg.controls.consumptions.controls.reduce<CreateEnergyOpportunityNaturalGasMeters>((obj, consumptionGroup) => {
                obj.estimatedAnnualConsumption! += +(consumptionGroup.controls.gas.value ?? 0)
                return obj;
            }, newCreateObject);

            if (fg.controls.hasPriceInput.value) {
                naturalGasMeter.energyPrice! = +(fg.controls.energyPrice.value ?? 0);
            }
            
            naturalGasMetersToInsert.naturalGasMeters.push(naturalGasMeter);
        })

        forkJoin({
            electricity: this._opportunityService.associateElectricityMeterToEnergyOpportunity(electricityMetersToInsert, opportunityId),
            naturalGas: this._opportunityService.associateNaturalGasMeterToEnergyOpportunity(naturalGasMetersToInsert, opportunityId)
        })
        .subscribe( {
            next: (srs: {[key: string]: ServerResponse<any[]>}) => {
                let requests: Observable<ServerResponse<any>>[] = [];
                
                Object.entries(srs).forEach( ([key, sr]) => {
                    if (sr.data) {
                        if (key == 'electricity') {
                            requests.push(...this._nonDeletedElectricityEquipmentFormArrayControls.map((fg: FormGroup<ElectricityFormGroup>) => { 
                                let consumptions: CreateElectricityMeterConsumption[] = fg.controls.consumptions.controls.map( (consumptionGroup: FormGroup<ConsumptionsFormGroup>) => {
                                    return new CreateElectricityMeterConsumption(
                                        consumptionGroup.controls.date.value!.toDateString(), 
                                        +(consumptionGroup.controls.offPeak.value ?? 0), 
                                        +(consumptionGroup.controls.peak.value ?? 0), 
                                        +(consumptionGroup.controls.standard.value ?? 0), 
                                        undefined,
                                        consumptionGroup.controls.superOffPeak.value != null ? +consumptionGroup.controls.superOffPeak.value : undefined
                                    );
                                });
                                
                                return this._energyMetersService.postElectricityMeterConsumptions(fg.controls.equipmentId.value!, consumptions)
                            }));
                            
                            requests.push(...sr.data.map( (energyOpportunity) => { 
                                let electricityGrouping = new CreateElectricityGrouping(
                                    [], 
                                    this.opportunityForm.controls.contractType.value!,
                                    energyOpportunity.electricityMeterId,
                                    energyOpportunity.id,
                                    this.opportunityForm.controls.groupingId.value!
                                );

                                return this._groupingService.createElectricityGrouping(electricityGrouping) 
                            }))
                        } else {
                            requests.push(...this._nonDeletedNaturalGasEquipmentFormArrayControls.flatMap((fg: FormGroup<NaturalGasFormGroup>) => { 
                                let consumptions: CreateNaturalGasMeterConsumption[] = fg.controls.consumptions.controls.map( (consumptionGroup: FormGroup<ConsumptionsFormGroup>) => {
                                    return new CreateNaturalGasMeterConsumption(
                                        consumptionGroup.controls.date.value!.toDateString(), 
                                        +(consumptionGroup.controls.gas.value ?? 0)
                                    );
                                });
            
                                return this._energyMetersService.postNaturalGasMeterConsumptions(fg.controls.equipmentId.value!, consumptions);
                            }));

                            requests.push(...sr.data.map( (energyOpportunity) => { 
                                let naturalGasGrouping = new CreateNaturalGasGrouping(
                                    [], 
                                    this.opportunityForm.controls.contractType.value!,
                                    energyOpportunity.naturalGasMeterId,
                                    energyOpportunity.id,
                                    this.opportunityForm.controls.groupingId.value!
                                );

                                return this._groupingService.createNaturalGasGrouping(naturalGasGrouping)
                            }));
                        }
                    }
                })
            
                if (requests.length > 0) {
                    forkJoin(requests).subscribe({
                        next: (srs: ServerResponse<any>[]) => {
                            if (srs.every((sr) => sr.data )) {
                                this._snackbarService.callSnackBar('EQUIPMENT_GROUP_CREATED_SUCCESSFULLY', SnackBarType.SUCCESS);
                                this._dialogRef.close();
                            }
                            
                        },
                        error: (err: Error) => {
                            this._snackbarService.callSnackBar('ERROR_ASSOCIATING_CONSUMPTIONS', SnackBarType.ERROR);
                        }
                    })
                } else {
                    this._snackbarService.callSnackBar('EQUIPMENT_GROUP_CREATED_SUCCESSFULLY', SnackBarType.SUCCESS);
                    this._dialogRef.close();
                }
            },

            error: (err: Error) => {
                this._snackbarService.callSnackBar('ERROR_ASSOCIATING_CONSUMPTIONS', SnackBarType.ERROR);
            }
        });

        
    }

    submitNaturalGasEquipments(nonCreatedEquipments: FormGroup<NaturalGasFormGroup>[]) {
        let naturalGasMeters: CreateNaturalGasMeterPT[] = nonCreatedEquipments
            .map((fg: FormGroup<NaturalGasFormGroup>) => { 
                const naturalGasMeterData = fg.value!;
                return { 
                    code: naturalGasMeterData.equipmentCode!, 
                    pressureLevelId: naturalGasMeterData.pressureLevel!, 
                    tariffOptionId: naturalGasMeterData.tariffOption!,
                    tierId: naturalGasMeterData.tier,
                    isISPFree: false,
                    address: {
                        country: this._userData.countryId,
                        postalCode: naturalGasMeterData.postalCode!,
                        postalCodeId: naturalGasMeterData.postalCodeId!,
                        parishId: +naturalGasMeterData.parish!,
                        street: naturalGasMeterData.street,
                        floorFraction: naturalGasMeterData.floor,
                        doorNumber: naturalGasMeterData.door
                    }
                }
            }
        );

        let naturalGasMetersRequest: {[key: string]: Observable<ServerResponse<any>>} = {};
        
        naturalGasMeters.forEach((meter: CreateNaturalGasMeterPT) => {
            naturalGasMetersRequest[meter.code] = this._energyMetersService.postNaturalGasMeter(meter);
        });

        forkJoin(naturalGasMetersRequest).subscribe( (srs: {[key: string]: ServerResponse<any>}) => {
            Object.entries(srs).forEach( ([key, response]) => {
                if (response.data != null) {
                    let associatedControl = this._naturalGasEquipmentFormArrayControls.find( (fg: FormGroup<NaturalGasFormGroup>) => fg.controls.equipmentCode.value == key);
                    associatedControl?.controls.equipmentId.setValue(response.data);
                }
            });
            
            this.submitCreateOpportunity();
        });
    }

    changeTensionLevel(selectEvent: any, index: number) {
        this._electricityEquipmentFormArrayAt(index)?.controls.tensionLevelString.setValue(selectEvent.description);
    }

    changeCountType(selectEvent: any, index: number) {
        this._electricityEquipmentFormArrayAt(index)?.controls.countTypeString.setValue(selectEvent.description);
    }

    openConsumptionMenu() {
        this.isOpen = true;
    }

    //#region Auxiliar Functions
    protected get _formControls(): OpportunityFormGroup {
        return this.opportunityForm.controls;
    }

    protected get _electricityEquipmentFormArray(): FormArray<FormGroup<ElectricityFormGroup>> {
        return this.opportunityForm.controls.electricityEquipments;
    }

    protected get _naturalGasEquipmentFormArray(): FormArray<FormGroup<NaturalGasFormGroup>> {
        return this.opportunityForm.controls.naturalGasEquipments;
    }

    protected get _electricityEquipmentFormArrayControls(): FormGroup<ElectricityFormGroup>[] {
        return this.opportunityForm.controls.electricityEquipments.controls;
    }
    protected get _nonDeletedElectricityEquipmentFormArrayControls(): FormGroup<ElectricityFormGroup>[] {
        return this._electricityEquipmentFormArrayControls.filter((fg) => fg.controls.deleted.value == false && fg.controls.associatedWithOpportunity.value == false);
    }

    protected get _naturalGasEquipmentFormArrayControls(): FormGroup<NaturalGasFormGroup>[] {
        return this.opportunityForm.controls.naturalGasEquipments.controls;
    }
    protected get _nonDeletedNaturalGasEquipmentFormArrayControls(): FormGroup<NaturalGasFormGroup>[] {
        return this._naturalGasEquipmentFormArrayControls.filter((fg) => fg.controls.deleted.value == false && fg.controls.associatedWithOpportunity.value == false);
    }

    protected get _equipmentFormArrayControls(): FormGroup<ElectricityFormGroup | NaturalGasFormGroup>[] {
        let arr: any[] = [];
        arr.push(...this.opportunityForm.controls.electricityEquipments.controls.filter( (gr: FormGroup<ElectricityFormGroup>) => !gr.controls.deleted.value ));
        arr.push(...this.opportunityForm.controls.naturalGasEquipments.controls.filter( (gr: FormGroup<NaturalGasFormGroup>) => !gr.controls.deleted.value ));
        
        return _.sortBy(arr, (fg) => { return fg.controls.internalOrder.value});
    }
    protected get _nonDeletedEquipmentFormArrayControls(): FormGroup<ElectricityFormGroup | NaturalGasFormGroup>[] {
        return this._equipmentFormArrayControls.filter((fg) => fg.controls.deleted.value == false);
    }

    protected get formHasChanges(): boolean {
        return !_.isEqual(this.formGroupInitialValue, this.opportunityForm.getRawValue());
    }

    protected _electricityEquipmentFormArrayAt(index: number): FormGroup<ElectricityFormGroup> | undefined {
        return this._electricityEquipmentFormArray.at(index);
    }

    protected _naturalGasEquipmentFormArrayAt(index: number): FormGroup<NaturalGasFormGroup> | undefined {
        return this._naturalGasEquipmentFormArray.at(index);
    }

    protected get _userData(): ClientPortalUser {
        return this._userService.userData!;
    }

    protected codeIsDuplicate(equipmentCode: string): boolean {
        return this._electricityEquipmentFormArrayControls.filter( (fg: FormGroup<ElectricityFormGroup>) => fg.controls.equipmentCode.value == equipmentCode ).length > 1;
    }

    protected changeEquipmentTab(equipmentIndex: number, tabNumber: number) {
        this.equipmentSelectedTabs[equipmentIndex] = tabNumber;
    }

    protected formGroupIsElectricity(formGroupControls: ElectricityFormGroup | NaturalGasFormGroup): formGroupControls is ElectricityFormGroup{
        return (formGroupControls as ElectricityFormGroup).tensionLevel != null;
    }

    protected _meterCodeRegexpPattern(isElectricity: boolean): RegExp {
        

        if (isElectricity) {
            if (this.countryCode == 'PT') {
                return new RegExp(RegExpPatterns.elecEquipmentPT);
            } else {
                return new RegExp(RegExpPatterns.elecEquipmentES);
            }
        } else {
            if (this.countryCode == 'PT') {
                return new RegExp(RegExpPatterns.ntrlGasEquipmentPT);
            } else {
                return new RegExp(RegExpPatterns.ntrlGasEquipmentES);
            }
        }
    }

    protected _zipCodeRegexpPattern(): RegExp {
        if (this.countryCode == 'PT') {
            return new RegExp(RegExpPatterns.postalCodePT);
        } else {
            return new RegExp(RegExpPatterns.postalCodeES);
        }
    }
    //#endregion
}

export type OpportunityFormGroup = {
    isOwnTin: FormControl<boolean>,
    tin: FormControl<number | null>,
    entity: FormControl<string | null>,
    date: FormControl<Date | null>,
    name: FormControl<string | null>,
    contractType: FormControl<string | null>,
    groupingId: FormControl<string | null>,
    opportunityId: FormControl<string | null>,
    loyaltyPeriod: FormControl<number | null>,

    electricityEquipments: FormArray<FormGroup<ElectricityFormGroup>>,
    naturalGasEquipments: FormArray<FormGroup<NaturalGasFormGroup>>
}

export type ElectricityFormGroup = {
    equipmentCode: FormControl<string | null>,
    equipmentId: FormControl<number | null>,
    contractedPower: FormControl<number | undefined>,
    tensionLevel: FormControl<string | undefined>,
    tensionLevelString: FormControl<string | undefined>,
    timeCycle: FormControl<string | undefined>,
    countType: FormControl<string | undefined>,
    countTypeString: FormControl<string | undefined>,

    county: FormControl<string | undefined>,
    district: FormControl<string | undefined>,
    locality: FormControl<string | undefined>,
    parish: FormControl<number | string | undefined>,
    street: FormControl<string | undefined>,
    floor: FormControl<string | undefined>,
    door: FormControl<string | undefined>,
    postalCode: FormControl<string | null>,
    postalCodeId: FormControl<number | null>,

    consumptions: FormArray<FormGroup<ConsumptionsFormGroup>>,

    offPeakEnergyPrice: FormControl<number | null>,
    peakEnergyPrice: FormControl<number | null>,
    standardEnergyPrice: FormControl<number | null>,
    superOffPeakEnergyPrice: FormControl<number | null>,

    hasPriceInput: FormControl<boolean | undefined>,
    hasSingleMonthConsumptionsInput: FormControl<boolean | undefined>,
    associatedWithOpportunity: FormControl<boolean>,
    deleted: FormControl<boolean>,

    internalOrder: FormControl<number>
}

export type NaturalGasFormGroup = {
    equipmentCode: FormControl<string | null>,
    equipmentId: FormControl<number | null>,
    pressureLevel: FormControl<string | undefined>,
    tariffOption: FormControl<string | undefined>,
    tier: FormControl<string | undefined>,

    county: FormControl<string | undefined>,
    district: FormControl<string | undefined>,
    locality: FormControl<string | undefined>,
    parish: FormControl<number | string | undefined>,
    street: FormControl<string | undefined>,
    floor: FormControl<string | undefined>,
    door: FormControl<string | undefined>,
    postalCode: FormControl<string | null>,
    postalCodeId: FormControl<number | null>,

    consumptions: FormArray<FormGroup<ConsumptionsFormGroup>>,

    energyPrice: FormControl<number | null>,

    hasPriceInput: FormControl<boolean | undefined>,
    hasSingleMonthConsumptionsInput: FormControl<boolean | undefined>,
    associatedWithOpportunity: FormControl<boolean>,
    deleted: FormControl<boolean>,

    internalOrder: FormControl<number>
}

export type ConsumptionsFormGroup = {
    date: FormControl<Date | undefined>,
    offPeak: FormControl<number | undefined>,
    peak: FormControl<number | undefined>,
    standard: FormControl<number | undefined>,
    superOffPeak: FormControl<number | undefined>,
    gas: FormControl<number | undefined>,
    id: FormControl<number | undefined>,
    singleLine: FormControl<boolean>
}